import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Settings from 'donor-elf-web/services/settings';

export default class AnnouncementComponent extends Component {
  @service declare settings: Settings;

  @action
  markRead() {
    let announcement = this.settings.announcement!;
    this.settings.announcement = undefined;
    announcement.read = true;
    announcement.save();
  }
}
